import React from "react";
import Chart from "react-apexcharts";
import "./PnLChart.scss";

const PnLChart = ({ selectedDateValue }) => {
  console.log("bhavesh1", selectedDateValue);

  const formattedData = selectedDateValue?.map((entry) => ({
    x: entry.date,
    y: entry.profit,
  }));
  console.log(formattedData)

  const options = {
    chart: {
      type: "area",
      height: 250,
      zoom: {
        enabled: true, // Enable zoom functionality
        type: "x", // Zoom along the x-axis only (optional)
        autoScaleYaxis: true, // Auto-scale y-axis when zooming (optional)
      },
      toolbar: {
        show: false, // Show the toolbar with zoom controls
        tools: {
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true, // Add a reset zoom button
        },
      },
    },
    colors: ["#007bff"], // Blue color for the line
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    tooltip: {
      enabled: true,
      theme: "dark",
      x: { format: "HH:mm:ss" },
      y: { formatter: (val) => `$${val.toLocaleString()}` },
      marker: { show: false },
    },
    xaxis: {
      type: "datetime",
      labels: {
        style: { colors: "#A1A1A1", fontSize: "12px" },
        datetimeFormatter: {
          hour: "HH:mm:ss",
          minute: "HH:mm:ss",
        },
      },
    },
    yaxis: {
      labels: {
        style: { colors: "#A1A1A1", fontSize: "12px" },
        formatter: (val) => {
      if (val < 0) {
        return `-$${Math.abs(val).toFixed(2)}`; // Show negative value with minus sign before $
      } else {
        return `$${val.toFixed(2)}`; // Regular positive value with $ before
      }
        },
      },
    },
    grid: { show: false },
    legend: { show: false },
    annotations: {
      position: "back",
    },
  };

  const series = [
    {
      name: "Net P & L",
      data: formattedData, // Use formatted data here
    },
  ];

  return (
    <div className="pnlChartContainer">
      <div className="pnlChartWrapper">
        <h4>Net P & L</h4>
      </div>
      <Chart options={options} series={series} type="area" height={150} />
    </div>
  );
};

export default PnLChart;
